module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tool')
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-84feacba!./~/vue-loader/lib/selector.js?type=template&index=0!./client/views/Tool.vue
// module id = 243
// module chunks = 0